import type { HovTabUnlockState } from "../types";
import { compareHuge, huge, type HugeNumber } from "@/shared/numbers";

export const HOV_TIM_BALANCE_UNLOCK_TIM_THRESHOLD: HugeNumber = huge("1e6");
export const HOV_TIM_GAIN_BALANCE_UNLOCK_HOV_THRESHOLD = 10000;
export const HOV_SKILL_UNLOCK_HOV_CORE_THRESHOLD = 1;

export function createDefaultHovTabUnlockState(): HovTabUnlockState {
  return {
    hovTarget: true,
    hovTimBalance: false,
    hovTimGainBalance: false,
    hovSkill: false,
  };
}

export function resolveHovTabUnlockState(options: {
  readonly hov: HugeNumber;
  readonly tim: HugeNumber;
  readonly hovCore: HugeNumber;
  readonly currentLoopHovEarned: HugeNumber;
  readonly existing?: Partial<HovTabUnlockState>;
}): HovTabUnlockState {
  const { hov, tim, hovCore, existing } = options;

  return {
    hovTarget: existing?.hovTarget ?? true,
    hovTimBalance:
      existing?.hovTimBalance === true ||
      compareHuge(tim, HOV_TIM_BALANCE_UNLOCK_TIM_THRESHOLD) > 0,
    hovTimGainBalance:
      existing?.hovTimGainBalance === true ||
      compareHuge(hov, HOV_TIM_GAIN_BALANCE_UNLOCK_HOV_THRESHOLD) > 0,
    hovSkill:
      existing?.hovSkill === true ||
      compareHuge(hovCore, HOV_SKILL_UNLOCK_HOV_CORE_THRESHOLD) >= 0,
  };
}
